import { fetchManager } from '../utils/fetchManager';

export const userService = {
  loadUserList: () => fetchManager('get', 'users'),

  loadUserBasicList: () => fetchManager('get', 'users-basic'),

  loadUser: userId => fetchManager('get', `users/${userId}`),

  updateUser: (userId, user) => fetchManager('put', `users/${userId}`, user),
};
